import React, { Component } from "react";
import QrReader from "react-qr-reader";

export default class QrReaderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      access: false,
    };
  }

  componentWillUnmount() {
    this.setState({ show: false });
  }

  render() {
    const { handleError, Check } = this.props;

    if (this.state.show) {
      return (
        <div className="text-center">
          <QrReader
            legacyMode={this.state.access}
            className="Qr-reader text-center"
            delay={500}
            onError={handleError}
            onScan={(data) => {
              if (data) {
                // var check = new_system.includes(data);
                // console.log(JSON.parse((data)));
                Check(JSON.parse((data)));
              } else {
                // console.log("your result isn't null", data);
              }
            }}
            style={{ width: "100%" }}
          />
          {/* <button onClick={() => this.setState({ access: !this.state.access })}>
            خاموش کردن دوربین
          </button> */}
        </div>
      );
    } else {
      return "";
    }
  }
}
